import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
  HttpStatusCode
} from '@angular/common/http';
import { catchError, Observable, of, tap, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class BackendInterceptor implements HttpInterceptor {

  constructor(private snackBar: MatSnackBar) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const creds = localStorage.getItem('creds');
    const modifiedRequest = request.clone({ headers: request.headers.set('Authorization', `Basic ${creds}`) });

    return next.handle(modifiedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        console.log('backend error', error);
        if (error.status != HttpStatusCode.Unauthorized) {
          this.snackBar.open(error.message, 'Ack');
          return of();
        }
        return throwError(() => error);
      })
    );
  }
}
